<template lang="pug">
  v-flex#confirmation-loans(xs12 sm12 md12 lg12)
    // - ALREADY IN STEP-3
    v-layout.mt-1(wrap row justify-center)
      v-flex.form-confirmation.border-gray(xs12 sm9 md5 lg4)
        img.mb-2(:src="icons.main" alt="confirmation-main")
        h2.omnesMedium Necesitamos validar que eres tú
        h3.mt-3.info--text Te hemos enviado una clave SMS al celular
        p.omnesMedium.info--text {{ celphoneEncrypt }}
        v-layout(wrap row justify-center)
          v-flex(xs9 sm8 md8 lg8)
            v-layout(row wrap justify-center)
              v-flex(xs2)
                v-text-field.enter-code(v-model="code" type="tel" ref="code" maxlength="1" placeholder=" " @keyup.native="validateCode($event, 1)")
              v-flex(xs2)
                v-text-field.enter-code(v-model="code2" type="tel" ref="code2" maxlength="1" placeholder=" " @keyup.native="validateCode($event, 2)")
              v-flex(xs2)
                v-text-field.enter-code(v-model="code3" type="tel" ref="code3" maxlength="1" placeholder=" " @keyup.native="validateCode($event, 3)")
              v-flex(xs2)
                v-text-field.enter-code(v-model="code4" type="tel" ref="code4" maxlength="1" placeholder=" " @keyup.native="validateCode($event, 4)")
              v-flex(xs2)
                v-text-field.enter-code(v-model="code5" type="tel" ref="code5" maxlength="1" placeholder=" " @keyup.native="validateCode($event, 5)" @keyup.enter="confirmTransact")
          v-flex(xs12 sm10 lg10 xl8)
            span.lh-1.info--text(style="margin-top: 13px;") Al hacer clic en confirmar, acepto que se realice los cambios ingresados con los términos y condiciones de la misma.
          v-flex(xs9 sm8 md8 lg8)
            br
            v-btn#btn-confirmation(color="primary" :disabled="!code || !code2 || !code3 || !code4 || !code5" @click="confirmTransact") Confirmar
            br
            p#btn_resendcode(@click="resendCodeMessage(celphone)") No he recibido el mensaje de texto
            a#btnBack(href="#" @click="backValidationPhone") VOLVER
    //- LOADER PROCESS
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | {{loaderMessage}}
          v-progress-linear.mb-0(indeterminate="" color="white")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import moment from 'moment'

export default {
  props: ['celular'],
  data () {
    return {
      msgLoadResend: 'Reenviando mensaje...',
      msgValidationCode: 'Validando mensaje...',
      loaderMessage: null,
      celphone: null,
      celphoneEncrypt: null,
      loader: false,
      code: null,
      code2: null,
      code3: null,
      code4: null,
      code5: null,
      icons: {
        main: require('./../assets/iconsv4/crear_cuenta_icon.svg')
      }
    }
  },
  computed: {
    ...mapGetters('user', ['userInfo', 'polizasInfo', 'basicInfo'])
  },
  methods: {
    ...mapActions('user', ['setCronogramaPago', 'validateCodigoPrestamo', 'setEstadoPrestamo', 'sendCronogramaPago', 'setTrackingClient', 'validateCodeValidationPhone', 'sendSMSValidationPhone']),
    validateCode (evt, pos) {
      let charCode = (evt.which) ? evt.which : evt.keyCode
      switch (pos) {
      case 1:
        if (this.code !== null && this.code !== '') { this.$refs.code2.focus() }
        break
      case 2:
        if (charCode === 8) {
          this.$refs.code.focus()
        } else if (this.code2 !== null && this.code2 !== '') {
          this.$refs.code3.focus()
        }
        break
      case 3:
        if (charCode === 8) {
          this.$refs.code2.focus()
        } else if (this.code3 !== null && this.code3 !== '') {
          this.$refs.code4.focus()
        }
        break
      case 4:
        if (charCode === 8) {
          this.$refs.code3.focus()
        } else if (this.code4 !== null && this.code4 !== '') {
          this.$refs.code5.focus()
        }
        break
      case 5:
        if (charCode === 8) {
          this.$refs.code4.focus()
        }
        break
      }
    },
    confirmTransact ($evt) {
      this.loader = true
      let codigo = this.code + this.code2 + this.code3 + this.code4 + this.code5

      const data = {
        userCode: this.userInfo.codigoUsuario,
        code: codigo
      }

      this.loaderMessage = this.msgValidationCode

      this.validateCodeValidationPhone(data)
        .then((res) => {
          if (res.data.codigoRespuesta === '01') {
            this.$root.$emit('finishValidationPhone', { status: 'OK' })
          }
        })
        .catch(() => {
          this.loader = false
          this.$swal({
            title: 'Advertencia',
            text: 'El código que has ingresado no es el correcto. Vuelve a intentarlo.',
            type: 'error',
            confirmButtonText: 'Entendido'
          })
        })
    },
    resendCodeMessage (cellphone) {
      this.loaderMessage = this.msgLoadResend
      this.loader = true
      const data = {
        userCode: this.userInfo.codigoUsuario,
        phoneNumber: this.celular
      }
      this.sendSMSValidationPhone(data).then(res => {
        this.loader = false
        if (res.status === 200 && res.data.codigoRespuesta === '01') {
          this.loader = false
        }
      })
        .catch(() => {
          this.loader = false
          this.$swal({
            title: 'Atención',
            text: 'Tuvimos inconvenientes al enviar el código de validacion via SMS.',
            imageUrl: require('./../assets/formpp/atencion-1.svg'),
            imageHeight: 180,
            imageWidth: 180,
            confirmButtonText: 'INTENTAR DE NUEVO'
          })
        })
    },
    backValidationPhone () {
      this.$root.$emit('backValidationPhone')
    },
    cellphoneEncrypted (cellphone) {
      const digitsEnd = 2
      const digitsIni = 3
      let result = ''
      for (let i = 0; i < cellphone.length; i++) {
        if (i < digitsIni || i > cellphone.length - digitsEnd - 1) {
          result += cellphone.substr(i, 1)
        } else {
          result += '*'
        }
      }
      return result
    }
  },
  mounted () {
    this.celphone = this.celular
    this.celphoneEncrypt = this.cellphoneEncrypted(this.celular)
  }
}
</script>

<style>
#btn_resendcode {
  color: #0855C4;
  font-size: 18px !important;
  margin-top: 1.5em;
  cursor: pointer;
}
#confirmation-loans #btnBack {
  font-size: 18px;
  font-weight: bold;
}
#confirmation-loans .header-loans h1 {
  text-align: center;
  margin-bottom: 1.3em;
  font-weight: normal;
}
#confirmation-loans .form-confirmation.border-gray {
  border: 1px solid #D8D8D8;
  padding-top: 2em;
  padding-bottom: 2em;
}
#confirmation-loans .form-confirmation { text-align: center; }
#confirmation-loans .form-confirmation img { width: 7rem; }
#confirmation-loans .form-confirmation p:first-of-type {
  font-family: 'Omnes Medium';
  font-size: 19px;
  margin-bottom: 5px;
  /* margin-top: 1.2em; */
}
#confirmation-loans .form-confirmation .enter-code .v-input__control .v-text-field__details { display: none; }
#confirmation-loans .form-confirmation .enter-code  { width: 85%; margin: 0 auto; display: block; }
#confirmation-loans .form-confirmation span:first-of-type {
  width: 90%;
  margin: 0 auto;
  display: block;
}
#confirmation-loans .form-confirmation span:first-of-type {
  font-size: 12px;
}
#confirmation-loans .form-confirmation .enter-code .v-input__control .v-input__slot .v-text-field__slot input {
  text-align: center;
  font-size: 25px;
  color: #0855C4;
  margin: 0;
  /* letter-spacing: 12px; */
}
#confirmation-loans button#btn-confirmation {
  padding: 1.5em 3em;
}
#confirmation-loans .form-confirmation p:first-of-type + p { margin-bottom: 2px; }
#confirmation-loans .form-confirmation p:first-of-type + p + p { font-family: 'Omnes Medium'; }
#confirmation-loans button#btn-confirmation:not(.v-btn--disabled) {
  background-color: rgb(234,12,144) !important;
  border-color: rgb(234,12,144) !important;
}
#confirmation-loans a { display: block; }
#confirmation-loans a:first-of-type { margin-top: 1.5em; }
#confirmation-loans a:first-of-type + a { margin-bottom: 1em; }
/* Small to large handset ----------- */
@media only screen and (max-width: 600px) {
  #confirmation-loans .form-confirmation p:first-of-type { font-size: 18px; }
  #confirmation-loans .form-confirmation span:first-of-type {
    width: 98%;
    margin: 0 auto;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ValidationPhone.vue